import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { useAuth } from 'hooks/useAuth/useAuth';
import { sendEventToSegment } from 'utils/functions/Tracking';
import TRACKING_EVENTS from 'utils/constants/trackingEvents';

const Banner = ({ className, children }) => {
  const { profile, termsAccepted } = useAuth();
  const [hide, setHide] = useState([]);
  const handleClose = useCallback(
    (name, preserve) => {
      if (!preserve) {
        localStorage.setItem(name, true);
      }
      setHide([...hide, name]);
      sendEventToSegment(TRACKING_EVENTS.BANNER_CLOSED, {
        name
      });
    },
    [hide]
  );
  const renderBanner = () => {
    if (!profile || !termsAccepted || !children) {
      return null;
    }
    return (
      <>
        {React.Children.toArray(children)
          .map((child, index) => {
            const { name, shouldShow, preserve } = child.props;
            if (
              !shouldShow ||
              localStorage.getItem(name) ||
              hide.includes(name)
            ) {
              return null;
            }
            return (
              <div
                className={className}
                data-testid="banner"
                key={`Banner-${name}-${index}`}
              >
                <div className="banner">
                  <button
                    className="banner__close"
                    data-testid="banner__button"
                    onClick={() => handleClose(name, preserve)}
                  >
                    <Icon glyph="close" size="2rem" />
                  </button>
                  <div className="banner__body" data-testid={name}>
                    {child}
                  </div>
                </div>
              </div>
            );
          })
          .find(child => child !== null)}
      </>
    );
  };
  return renderBanner();
};
Banner.propTypes = {
  className: PropTypes.string
};
export default Banner;
